import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'

import { Text } from '@/ui'
import { EnableDialog } from './EnableDialog'
import { DisableDialog } from './DisableDialog'

export const TwoFactorAuthentication = () => {
  const user = useReselector(getCurrentUser)

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="md:w-[420px] flex flex-col gap-2">
        <Text>
          Two-factor authentication (2FA) is an extra layer of security. Once
          enabled, you&#39;ll be required to give two types of identification
          when you log into Heard. We currently support 2FA via SMS only.
        </Text>

        {user?.twoFactorAuthEnabled && (
          <Text>
            Two-factor authentication is <b>ON</b> for your phone number ending
            in {user.phoneNumber?.slice(-4)}
          </Text>
        )}
      </div>

      <div className="w-full md:w-auto">
        {user?.twoFactorAuthEnabled ? <DisableDialog /> : <EnableDialog />}
      </div>
    </div>
  )
}
